// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class RbacRole_abstract extends PersistentObject {
  static $t: string = 'SagaBase.RBAC.RbacRole';
  $t: string = 'SagaBase.RBAC.RbacRole';

  public static GetMembers(): string[] {
    return ['ObjId', 'Name', 'Description', 'IsHidden', 'IsDefault', 'ApplicationProfileId'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return RbacRole_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ObjId: any;
  public Name: string;
  public Description: string;
  public IsHidden: boolean = false;
  public IsDefault: boolean = false;
  public ApplicationProfileId: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
